export enum PaymentPreference {
    CHECK = 'Check',
    EFT = 'EFT (direct deposit)'
}